import { IconInfo } from './IconInfo';

export type IconMap = Record<string, IconInfo>;
